import React from 'react';
import { motion } from 'framer-motion';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  light?: boolean;
  className?: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  subtitle,
  centered = false,
  light = false,
  className = '',
}) => {
  const textAlignClass = centered ? 'text-center mx-auto' : '';
  const textColorClass = light ? 'text-white' : 'text-neutral-900';
  const subtitleColorClass = light ? 'text-neutral-300' : 'text-neutral-600';

  return (
    <div className={`max-w-3xl mb-12 ${textAlignClass} ${className}`}>
      <motion.h2
        className={`text-3xl md:text-4xl font-bold font-serif ${textColorClass}`}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          className={`mt-4 text-xl ${subtitleColorClass}`}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: true }}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
};

export default SectionTitle;